import { checkAuth } from "@/services/Auth";
import { createRouter, createWebHistory } from "vue-router";
import Body from "../components/body";

import HomeView from "../views/web/HomeView";

/* Dashboards */
// import Default from "../pages/dashboard/default";
// import Ecommerce from "../pages/dashboard/ecommerce";
// import Online from "../pages/dashboard/online";
// import Crypto from "../pages/dashboard/crypto";
// import Social from "../pages/dashboard/social.vue";
import Footer from "../views/admin/Footer.vue";
import HamburgerMenu from "../views/admin/header/HamburgerMenu.vue";
import IconMenu from "../views/admin/header/IconMenu.vue";
import MainMenu from "../views/admin/header/MainMenu.vue";
import ResponsiveMenu from "../views/admin/header/ResponsiveMenu.vue";
import MediaPage from "../views/admin/MediaPage.vue";
import AboutUs from "../views/admin/pages/AboutUs.vue";
import Homepage from "../views/admin/pages/Homepage/Homepage.vue";
import McdApp from "../views/admin/pages/McdApp.vue";
import Profile from "../views/admin/Profile.vue";
import SupportTicket from "../views/admin/SupportTicket.vue";
/* Maps */
// import GoogleMaps from "../pages/maps/google_map.vue";

// pageLayout
// import indexBoxed from "../pages/pageLayout/boxed/indexBoxed.vue";
// import indexRTL from "../pages/pageLayout/RTL/indexRTL.vue";
// import indexDarklayout from "../pages/pageLayout/darklayout/indexDarklayout.vue";
// import indexFooterdark from "../pages/pageLayout/footerdark/indexFooterdark.vue";
// import indexFooterfixed from "../pages/pageLayout/footerfixed/indexFooterfixed.vue";
// import indexFooterlight from "../pages/pageLayout/footerlight/indexFooterlight.vue";
// import indexHidenavscroll from "../pages/pageLayout/hidenavscroll/indexHidenavscroll.vue";

// error
import Error400 from "../pages/error/error400";
import Error401 from "../pages/error/error401";
import Error403 from "../pages/error/error403";
import Error500 from "../pages/error/error500";
import Error503 from "../pages/error/error503";

/* Auth */

const routes = [
  // admin dashboard
  {
    path: "/admin/login",
    name: "login",
    component: () => import("../views/admin/AdminLogin.vue"),
    meta: {
      hideHeader: true, // Indicate that the header should be hidden for this route
      hideFooter: true, // Indicate that the footer should be hidden for this route
      hideSideIcons: true, // Indicate that the footer should be hidden for this route
    },
  },
  {
    path: "/admin/header",
    component: Body,
    meta: {
      hideHeader: true, // Indicate that the header should be hidden for this route
      hideFooter: true, // Indicate that the footer should be hidden for this route
      hideSideIcons: true, // Indicate that the footer should be hidden for this route
      hideToTopBtn: true,
    },
    children: [
      {
        path: "mainmenu",
        name: "mainmenu",
        component: MainMenu,
        meta: {
          title: "",
        },
      },
      {
        path: "hamburgermenu",
        name: "hamburgermenu",
        component: HamburgerMenu,
        meta: {
          title: "",
        },
      },
      {
        path: "responsivemenu",
        name: "responsivemenu",
        component: ResponsiveMenu,
        meta: {
          title: "",
        },
      },
      {
        path: "iconmenu",
        name: "iconmenu",
        component: IconMenu,
        meta: {
          title: "",
        },
      },
    ],
  },
  {
    path: "/admin/pages",
    component: Body,
    meta: {
      requiresAuth: true,
      hideHeader: true, // Indicate that the header should be hidden for this route
      hideFooter: true, // Indicate that the footer should be hidden for this route
      hideSideIcons: true, // Indicate that the footer should be hidden for this route
      hideToTopBtn: true, // Indicate that the footer should be hidden for this route
    },
    children: [
      {
        path: "home",
        name: "admin-home-page",
        component: Homepage,
      },
      {
        path: "about-us",
        name: "admin-about-us",
        component: AboutUs,
      },
      {
        path: "menu",
        name: "admin-menu-page",
        component: () => import("../views/admin/pages/Menu/Menu.vue"),
      },
      {
        path: "addmenu",
        name: "admin-add-menu",
        component: () => import("../views/admin/pages/Menu/AddMenu.vue"),
      },
      {
        path: "menu/details/:id",
        name: "admin-edit-menu",
        component: () => import("../views/admin/pages/Menu/EditMenu.vue"),
      },
      {
        path: "contact-us",
        name: "admin-contact-us",
        component: () => import("../views/admin/pages/ContactUs/index.vue"),
      },
      {
        path: "work-with-us",
        name: "admin-work-with-us",
        component: () => import("../views/admin/pages/WorkWithUs/index.vue"),
      },
      {
        path: "restaurant/vacancy/add",
        props: { option: 1 },
        name: "admin-restaurant-add",
        component: () =>
          import("../views/admin/pages/WorkWithUs/AddRestaurantVacancy.vue"),
      },
      {
        path: "corporate/vacancy/add",
        props: { option: 2 },
        name: "admin-corporate-add",
        component: () =>
          import("../views/admin/pages/WorkWithUs/AddRestaurantVacancy.vue"),
      },
      {
        path: "tender/add",
        props: { option: 12 },
        name: "admin-tender-add",
        component: () =>
          import("../views/admin/pages/WorkWithUs/TenderAdd.vue"),
      },
      {
        path: "restaurant/vacancy/edit",
        name: "admin-restaurant-edit",
        props: { edit: true, option: 1 },
        component: () =>
          import("../views/admin/pages/WorkWithUs/EditRestaurantVacancy.vue"),
      },
      {
        path: "corporate/vacancy/edit",
        name: "admin-corporate-edit",
        props: { edit: true, option: 2 },
        component: () =>
          import("../views/admin/pages/WorkWithUs/EditRestaurantVacancy.vue"),
      },
      {
        path: "tender/edit",
        name: "admin-tender-edit",
        props: { edit: true, option: 12 },
        component: () =>
          import("../views/admin/pages/WorkWithUs/TenderEdit.vue"),
      },
      {
        path: "restaurant/vacancy/view",
        name: "admin-restaurant-view",
        props: { edit: false },
        component: () =>
          import("../views/admin/pages/WorkWithUs/EditRestaurantVacancy.vue"),
      },
      {
        path: "corporate/vacancy/view",
        name: "admin-corporate-view",
        props: { edit: false },
        component: () =>
          import("../views/admin/pages/WorkWithUs/EditRestaurantVacancy.vue"),
      },
      {
        path: "tender/view",
        name: "admin-tender-view",
        props: { edit: false },
        component: () =>
          import("../views/admin/pages/WorkWithUs/TenderEdit.vue"),
      },
      {
        path: "promotion",
        name: "admin-promotion",
        component: () => import("../views/admin/pages/Promotion/Promotion.vue"),
      },
      {
        path: "addpromo",
        name: "admin-add-promo",
        component: () => import("../views/admin/pages/Promotion/AddPromo.vue"),
      },
      {
        path: "promo/details/:id",
        name: "admin-edit-promo",
        component: () => import("../views/admin/pages/Promotion/EditPromo.vue"),
      },
      {
        path: "mcd-app",
        name: "mcdApp",
        component: McdApp,
      },
      {
        path: "faqs",
        name: "admin-faqs",
        component: () => import("../views/admin/pages/Faqs/Index.vue"),
      },
      {
        path: "community",
        name: "admin-community",
        component: () => import("../views/admin/pages/Community/Index.vue"),
      },
      {
        path: "community/add",
        name: "admin-community-add",
        component: () => import("../views/admin/pages/Community/Add.vue"),
      },
      {
        path: "community/edit",
        name: "admin-community-edit",
        props: { edit: true },
        component: () => import("../views/admin/pages/Community/Edit.vue"),
      },
      {
        path: "community/view",
        name: "admin-community-view",
        props: { edit: false },
        component: () => import("../views/admin/pages/Community/Edit.vue"),
      },
      {
        path: "terms-conditions",
        name: "admin-termsCondtions",
        component: () =>
          import("../views/admin/pages/TermsConditions/Index.vue"),
      },
      {
        path: "privacy-policy",
        name: "admin-privacyPolicy",
        component: () => import("../views/admin/pages/PrivacyPolicy/Index.vue"),
      },
    ],
  },
  {
    path: "/app",
    component: Body,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "/dashboard",
        component: () => import("../views/admin/AdminDashboard.vue"),
        meta: {
          hideHeader: true, // Indicate that the header should be hidden for this route
          hideFooter: true, // Indicate that the footer should be hidden for this route
          hideSideIcons: true, // Indicate that the footer should be hidden for this route
          hideToTopBtn: true,
        },
      },
      {
        path: "/admin/footer",
        name: "footer",
        component: Footer,
        meta: {
          hideHeader: true, // Indicate that the header should be hidden for this route
          hideFooter: true, // Indicate that the footer should be hidden for this route
          hideSideIcons: true, // Indicate that the footer should be hidden for this route
          hideToTopBtn: true,
        },
      },
      {
        path: "/admin/media",
        name: "admin-media",
        component: MediaPage,
        meta: {
          hideHeader: true, // Indicate that the header should be hidden for this route
          hideFooter: true, // Indicate that the footer should be hidden for this route
          hideSideIcons: true, // Indicate that the footer should be hidden for this route
          hideToTopBtn: true,
        },
      },
      {
        path: "/admin/menu",
        name: "admin-menu",
        component: () => import("../views/admin/pages/Menu/Menu.vue"),
        meta: {
          hideHeader: true, // Indicate that the header should be hidden for this route
          hideFooter: true, // Indicate that the footer should be hidden for this route
          hideSideIcons: true, // Indicate that the footer should be hidden for this route
          hideToTopBtn: true,
        },
      },
      {
        path: "/admin/addmenu",
        name: "admin-add-menu",
        component: () => import("../views/admin/pages/Menu/AddMenu.vue"),
        meta: {
          hideHeader: true, // Indicate that the header should be hidden for this route
          hideFooter: true, // Indicate that the footer should be hidden for this route
          hideSideIcons: true, // Indicate that the footer should be hidden for this route
          hideToTopBtn: true,
        },
      },
      {
        path: "/admin/menu/details/:id",
        name: "admin-edit-menu",
        component: () => import("../views/admin/pages/Menu/EditMenu.vue"),
        meta: {
          hideHeader: true, // Indicate that the header should be hidden for this route
          hideFooter: true, // Indicate that the footer should be hidden for this route
          hideSideIcons: true, // Indicate that the footer should be hidden for this route
          hideToTopBtn: true,
        },
      },
      {
        path: "/admin/approval",
        name: "admin-approval",
        component: () => import("../views/admin/ApprovalPage.vue"),
        meta: {
          hideHeader: true, // Indicate that the header should be hidden for this route
          hideFooter: true, // Indicate that the footer should be hidden for this route
          hideSideIcons: true, // Indicate that the footer should be hidden for this route
          hideToTopBtn: true,
        },
      },
      {
        path: "/admin/logs",
        name: "admin-logs",
        component: () => import("../views/admin/ActivityLogs.vue"),
        meta: {
          hideHeader: true, // Indicate that the header should be hidden for this route
          hideFooter: true, // Indicate that the footer should be hidden for this route
          hideSideIcons: true, // Indicate that the footer should be hidden for this route
          hideToTopBtn: true,
        },
      },
      {
        path: "/admin/settings",
        name: "admin-settings",
        component: () => import("../views/admin/pages/Settings.vue"),
        meta: {
          hideHeader: true, // Indicate that the header should be hidden for this route
          hideFooter: true, // Indicate that the footer should be hidden for this route
          hideSideIcons: true, // Indicate that the footer should be hidden for this route
          hideToTopBtn: true,
        },
      },
      {
        path: "/admin/profile",
        name: "profile",
        component: Profile,
        meta: {
          hideHeader: true, // Indicate that the header should be hidden for this route
          hideFooter: true, // Indicate that the footer should be hidden for this route
          hideSideIcons: true, // Indicate that the footer should be hidden for this route
          hideToTopBtn: true,
        },
      },
      {
        path: "/admin/support",
        name: "support",
        component: SupportTicket,
        meta: {
          hideHeader: true, // Indicate that the header should be hidden for this route
          hideFooter: true, // Indicate that the footer should be hidden for this route
          hideSideIcons: true, // Indicate that the footer should be hidden for this route
          hideToTopBtn: true,
        },
      },
    ],
  },

  // public view
  {
    path: "/home",
    name: "home-view",
    component: HomeView,
  },
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/search",
    name: "search-page",
    component: () => import("../views/web/SearchPage.vue"),
  },
  {
    path: "/hamburger-menu",
    name: "hamburger-menu",
    component: () => import("../views/web/BurgerMenu.vue"),
    hideFooter: true, // Indicate that the footer should be hidden for this route
    hideSideIcons: true, // Indicate that the footer should be hidden for this route
  },
  {
    path: "/privacy-policy",
    name: "privacy-page",
    component: () => import("../views/web/PrivacyPolicy.vue"),
  },
  {
    path: "/terms-conditions",
    name: "terms-conditions-page",
    component: () => import("../views/web/TermConditions.vue"),
  },
  {
    path: "/faqs",
    name: "faq-page",
    component: () => import("../views/web/Faqs.vue"),
  },
  {
    path: "/about-us-main",
    name: "about-us-main",
    component: () => import("../views/web/AboutUs/AboutUsMain.vue"),
  },
  {
    path: "/about-us",
    name: "about-us",
    component: () => import("../views/web/AboutUs/AboutUs.vue"),
  },
  {
    path: "/history",
    name: "history",
    component: () => import("../views/web/AboutUs/History.vue"),
  },
  {
    path: "/corporate-milestone",
    name: "corporate-milestone",
    component: () => import("../views/web/AboutUs/CorporateMilestone.vue"),
  },
  {
    path: "/mission-vision",
    name: "mission-vision",
    component: () => import("../views/web/AboutUs/MissionVision.vue"),
  },
  {
    path: "/contact",
    name: "contact-page",
    component: () => import("../views/web/ContactPage.vue"),
  },
  {
    path: "/community",
    name: "community-page",
    component: () => import("../views/web/Community/Main.vue"),
  },
  {
    path: "/community/news",
    name: "community-news-page",
    component: () => import("../views/web/Community/News.vue"),
  },
  {
    path: "/community/gallery",
    name: "community-gallery-page",
    component: () => import("../views/web/Community/Gallery.vue"),
  },
  {
    path: "/community/:id/details",
    // path: "/community/news/details",
    name: "community-news-details-page",
    props: true,
    component: () => import("../views/web/Community/NewsDetails.vue"),
  },
  {
    path: "/promotion",
    name: "promotion-page",
    component: () => import("../views/web/PromotionPage.vue"),
  },
  {
    path: "/promotion/:id/details",
    name: "promotion-details",
    component: () => import("../views/web/PromotionDetails.vue"),
  },
  {
    path: "/menu",
    name: "menu",
    component: () => import("../views/web/Menu.vue"),
    props: true,
  },
  {
    path: "/menu-details/:id",
    name: "menu-details",
    component: () => import("../views/web/MenuItemDetails.vue"),
  },
  {
    path: "/mcd-app",
    name: "/mcd-app",
    component: () => import("../views/web/McDApp.vue"),
  },
  {
    path: "/work-with-us",
    name: "work-with-us-page",
    component: () => import("../views/web/WorkWithUs/Main.vue"),
  },
  {
    path: "/work-with-us/join",
    name: "work-with-us-join-page",
    component: () => import("../views/web/WorkWithUs/Join.vue"),
  },
  {
    path: "/work-with-us/corporate",
    name: "work-with-us-corporate-page",
    component: () => import("../views/web/WorkWithUs/Corporate.vue"),
  },
  {
    path: "/work-with-us/tender",
    name: "work-with-us-tender-page",
    component: () => import("../views/web/WorkWithUs/Tender.vue"),
  },
  {
    path: "/test",
    name: "test",
    component: () => import("../views/web/test.vue"),
    meta: {
      hideHeader: true, // Indicate that the header should be hidden for this route
      hideFooter: true, // Indicate that the footer should be hidden for this route
      hideSideIcons: true, // Indicate that the footer should be hidden for this route
    },
  },
  {
    path: "/vouchers",
    name: "promo-page",
    component: () => import("../views/web/PromoPage.vue"),
    meta: {
      hideHeader: true, // Indicate that the header should be hidden for this route
      hideFooter: true, // Indicate that the footer should be hidden for this route
      hideSideIcons: true, // Indicate that the footer should be hidden for this route
    },
  },
  {
    path: "/voucher-code",
    name: "promo-code-page",
    component: () => import("../views/web/PromoCode.vue"),
    meta: {
      hideHeader: true, // Indicate that the header should be hidden for this route
      hideFooter: true, // Indicate that the footer should be hidden for this route
      hideSideIcons: true, // Indicate that the footer should be hidden for this route
    },
  },
  {
    path: "/success",
    name: "success-page",
    component: () => import("../views/web/SuccessPage.vue"),
    meta: {
      hideHeader: true, // Indicate that the header should be hidden for this route
      hideFooter: true, // Indicate that the footer should be hidden for this route
      hideSideIcons: true, // Indicate that the footer should be hidden for this route
    },
  },

  // {
  //   path: "/dashboard",
  //   component: Body,
  //   meta: {
  //     requiresAuth: true,
  //   },
  //   children: [
  //     {
  //       path: "ecommerce",
  //       name: "admin-ecommerce",
  //       component: Ecommerce,
  //       meta: {
  //         title: "Ecommerce Dashboard | Cuba - Premium Admin Template",
  //       },
  //     },
  //     {
  //       path: "online",
  //       name: "admin-online",
  //       component: Online,
  //       meta: {
  //         title: "Online Dashboard | Cuba - Premium Admin Template",
  //       },
  //     },
  //     {
  //       path: "social",
  //       name: "admin-social",
  //       component: Social,
  //       meta: {
  //         title: "Social Dashboard | Cuba - Premium Admin Template",
  //       },
  //     },
  //   ],
  // },

  {
    path: "/error-400",
    name: "Error400",
    component: Error400,
    meta: {
      title: "Error400 | Cuba - Premium Admin Template",
    },
  },
  {
    path: "/error-401",
    name: "Error401",
    component: Error401,
    meta: {
      title: "Error401 | Cuba - Premium Admin Template",
    },
  },
  {
    path: "/error-403",
    name: "Error403",
    component: Error403,
    meta: {
      title: "Error403 | Cuba - Premium Admin Template",
    },
  },
  {
    path: "/error-404",
    name: "Error404",
    component: () => import("../views/web/Error/404.vue"),
  },
  {
    path: "/error-500",
    name: "Error500",
    component: Error500,
    meta: {
      title: "Error500 | Cuba - Premium Admin Template",
    },
  },
  {
    path: "/error-503",
    name: "Error503",
    component: Error503,
    meta: {
      title: "Error503 | Cuba - Premium Admin Template",
    },
  },

  // {
  //   path: "/auth",
  //   children: [
  //     {
  //       path: "admin",
  //       name: "admin-login",
  //       component: login,
  //       meta: {
  //         title: " login | Cuba - Premium Admin Template",
  //       },
  //     },
  //   ],
  // },
  // {
  //   path: "/maps",
  //   component: Body,
  //   children: [
  //     {
  //       path: "vue-google-maps",
  //       name: "GoogleMaps",
  //       component: GoogleMaps,
  //       meta: {
  //         title: "GoogleMaps | Cuba - Premium Admin Template",
  //       },
  //     },
  //   ],
  // },
];
const router = createRouter({
  history: createWebHistory(),
  routes,
  linkExactActiveClass: "active",
});
router.beforeEach((to, from, next) => {
  checkAuth();

  // Scroll to the top of the page
  window.scrollTo(0, 0);

  const path = [
    "/auth/admin",
    "/contact",
    "/home",
    "/faqs",
    "/terms-conditions",
    "/privacy-policy",
    "/community",
    "/promotion",
    "/promotion/:id/details",
    "/home/asd",
    "/search",
    "/menu",
    "/menu-details/:id",
    "/test",
    "/mcd-app",
    "/admin/login",
    "/admin/profile",
    "/admin/menu",
    "/admin/support",
    "/work-with-us",
    "/about-us-main",
    "/about-us",
    "/history",
    "/corporate-milestone",
    "/mission-vision",
    "/work-with-us/join",
    "/work-with-us/corporate",
    "/work-with-us/tender",
    "/community/news",
    "/community/:id/details",
    "/community/gallery",
    "/error-404",
    "/promotion/:id/details",
    "/vouchers",
    "/voucher-code",
    "/success"
  ];

  const resolvedRoute = router.resolve(to);

  const isPathAllowed = path.some((pathPattern) => {
    const pattern = pathPattern.replace(/:id/g, "\\d+"); // Match numeric values

    const regex = new RegExp("^" + pattern + "$");
    return regex.test(to.path);
  });

  if (path.includes(to.path) || isPathAllowed) {
    return next();
  }

  if (resolvedRoute.matched.length === 0) {
    next("/error-404");
  }

  if (!path.includes(to.path) && localStorage.getItem("token")) {
    return next();
  }

  if (
    resolvedRoute.matched.length > 0 &&
    !path.includes(to.path) &&
    !localStorage.getItem("token")
  ) {
    return next("/error-404");
  }

  return next(false);
});
export default router;
